<template>
  <svg width="24px" height="24px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 2H13V4.41421L9.41421 8L13 11.5858V14H14V16H2V14H3V11.5858L6.58579 8L3 4.41421V2H2V0H14V2ZM5 2V3.58579L8 6.58579L11 3.58579V2H5ZM8 9.41421L5 12.4142V14H11V12.4142L8 9.41421Z" fill="currentColor"/>
  </svg>
</template>
